<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- العنوان الرئيسي وزر الحفظ العام -->
    <div class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded shadow-sm border-start border-5 border-primary">
      <div>
        <h4 class="fw-bold text-primary mb-1">
          <i class="fas fa-cogs ms-2"></i> لوحة تحكم إعدادات النظام
        </h4>
        <p class="text-muted small mb-0">التحكم المركزي في جميع خصائص الكنترول والموقع</p>
      </div>
      <button @click="saveAllSettings" class="btn btn-success fw-bold px-4 shadow-sm btn-hover" :disabled="saving">
        <span v-if="saving" class="spinner-border spinner-border-sm ms-1"></span>
        <span v-else><i class="fas fa-save ms-1"></i> حفظ كافة التعديلات</span>
      </button>
    </div>

    <div class="row">
      
      <!-- 1. القائمة الجانبية (Tabs) -->
      <div class="col-md-3 mb-4">
        <div class="list-group shadow-sm sticky-top" style="top: 20px; z-index: 1;">
          
          <button @click="activeTab = 'general'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'general' }">
            <span><i class="fas fa-sliders-h ms-2 text-secondary"></i> عام وقفل الموقع</span>
            <i class="fas fa-chevron-left small opacity-50"></i>
          </button>

          <!-- التبويب الخاص بحجب الروابط -->
          <button @click="activeTab = 'menu_manager'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'menu_manager' }">
            <span><i class="fas fa-eye-slash ms-2 text-danger"></i> حجب الروابط والأقسام</span>
            <i class="fas fa-chevron-left small opacity-50"></i>
          </button>

          <button @click="activeTab = 'services'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'services' }">
            <span><i class="fas fa-toggle-on ms-2 text-success"></i> خدمات الجمهور والتظلمات</span>
            <i class="fas fa-chevron-left small opacity-50"></i>
          </button>
          
          <button @click="activeTab = 'seasons'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'seasons' }">
            <span><i class="fas fa-calendar-alt ms-2 text-info"></i> الفصول الدراسية</span>
            <i class="fas fa-chevron-left small opacity-50"></i>
          </button>

          <button @click="activeTab = 'grading'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'grading' }">
            <span><i class="fas fa-pen-nib ms-2 text-warning"></i> قواعد الرصد والرأفة</span>
            <i class="fas fa-chevron-left small opacity-50"></i>
          </button>

          <button @click="activeTab = 'control'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'control' }">
            <span><i class="fas fa-user-secret ms-2 text-dark"></i> الجلوس والسري</span>
            <i class="fas fa-chevron-left small opacity-50"></i>
          </button>

          <button @click="activeTab = 'printing'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'printing' }">
            <span><i class="fas fa-print ms-2 text-primary"></i> ترويسة التقارير</span>
            <i class="fas fa-chevron-left small opacity-50"></i>
          </button>
          <button @click="activeTab = 'users_manager'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center text-dark fw-bold" :class="{ active: activeTab === 'users_manager' }">
            <span><i class="fas fa-user-edit ms-2 text-primary"></i> إدارة المستخدمين (تعديل)</span>
            <i class="fas fa-chevron-left small opacity-50"></i>
          </button>
          <button @click="activeTab = 'users'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'users' }">
            <span><i class="fas fa-users-cog ms-2 text-secondary"></i> استيراد مستخدمين</span>
            <i class="fas fa-chevron-left small opacity-50"></i>
          </button>

          <button @click="activeTab = 'advanced'" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center text-danger mt-3 border border-danger bg-danger-subtle" :class="{ active: activeTab === 'advanced' }">
            <span class="fw-bold"><i class="fas fa-radiation ms-2"></i> منطقة الخطر</span>
            <i class="fas fa-chevron-left small"></i>
          </button>
        </div>
      </div>

      <!-- 2. محتوى التبويبات -->
      <div class="col-md-9">
        <div class="card shadow-sm border-0 min-vh-100">
          <div class="card-body p-4">
            
            <!-- Tab 1: إعدادات عامة + قفل الموقع -->
            <div v-if="activeTab === 'general'" class="animate-fade">
              <h5 class="section-title text-primary">بيانات الكنترول الأساسية</h5>
              <div class="row g-3 mb-4">
                <div class="col-md-6">
                  <label class="form-label fw-bold">اسم الكنترول (يظهر في الموقع)</label>
                  <input type="text" v-model="settings.general.controlName" class="form-control" />
                </div>
                <div class="col-md-12">
                  <label class="form-label fw-bold">شريط الأخبار (News Ticker)</label>
                  <textarea v-model="settings.general.newsTicker" class="form-control" rows="2" placeholder="اكتب خبراً عاجلاً ليظهر في الشريط العلوي..."></textarea>
                </div>
              </div>

              <!-- قسم قفل الموقع -->
              <h5 class="section-title text-danger mt-5">التحكم في حالة الموقع (Maintenance)</h5>
              <div class="card bg-danger-subtle border-danger mb-3">
                  <div class="card-body">
                      <div class="d-flex justify-content-between align-items-center mb-3">
                          <div>
                              <h6 class="fw-bold text-danger mb-1"><i class="fas fa-lock ms-2"></i> تفعيل وضع الصيانة</h6>
                              <p class="mb-0 small text-muted">إغلاق الموقع أمام الزوار والمدارس.</p>
                          </div>
                          <div class="form-check form-switch">
                              <input class="form-check-input" type="checkbox" v-model="settings.general.is_maintenance_mode" style="transform: scale(1.6); cursor: pointer;">
                          </div>
                      </div>

                      <div v-if="settings.general.is_maintenance_mode" class="row g-3 border-top border-danger-subtle pt-3 animate-fade">
                          <div class="col-md-6">
                              <label class="fw-bold text-danger small">المفتاح السري (للدخول أثناء القفل)</label>
                              <input type="text" v-model="settings.general.maintenance_secret" class="form-control fw-bold">
                          </div>
                          <div class="col-md-6">
                              <label class="fw-bold text-danger small">رسالة الصيانة</label>
                              <input type="text" v-model="settings.general.maintenance_message" class="form-control">
                          </div>
                      </div>
                  </div>
              </div>
            </div>

            <!-- Tab 2: حجب الروابط (Menu Visibility) -->
 <div v-if="activeTab === 'menu_manager'" class="animate-fade">
              <h5 class="section-title text-danger">
                  <i class="fas fa-eye-slash ms-2"></i> التحكم في ظهور القوائم الوظيفية
              </h5>
              <div class="alert alert-light border-start border-4 border-warning shadow-sm mb-4">
                  <i class="fas fa-info-circle text-warning fa-lg ms-2"></i>
                  <strong>تنبيه:</strong> إلغاء تفعيل أي رابط سيؤدي لإخفائه عن جميع الموظفين (الكنترول، المدارس، اللجان) فوراً.
              </div>
              <div :key="menuKey">
              <!-- حلقة تكرار لعرض الروابط والتحكم بها -->
              <div v-for="mainLink in filteredMenuLinks" :key="mainLink.name" class="card mb-3 border-0 shadow-sm">
                
                <!-- الرابط الرئيسي (الأب) -->
                <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center py-3">
                  <div class="d-flex align-items-center">
                      <div class="icon-box bg-light rounded-circle text-secondary ms-3">
                          <i :class="mainLink.icon"></i>
                      </div>
                      <div>
                          <h6 class="fw-bold text-dark mb-0">{{ mainLink.text }}</h6>
                          <span class="badge bg-secondary-subtle text-secondary small" style="font-size: 0.7rem;">{{ mainLink.roles.join(', ') }}</span>
                      </div>
                  </div>
                  
                  <!-- زر التبديل الرئيسي -->
                  <div class="form-check form-switch">
                    <input 
                        class="form-check-input" 
                        type="checkbox" 
                        v-model="settings.menu_visibility[mainLink.name]" 
                        style="transform: scale(1.5); cursor: pointer;"
                    >
                  </div>
                </div>
                
                <!-- الروابط الفرعية (الأبناء) -->
                <!-- يظهر هذا القسم فقط إذا كان الأب مفعلاً (True) -->
                <div class="card-body bg-light-subtle" v-if="mainLink.hasChildren && settings.menu_visibility[mainLink.name] !== false">
                  <div class="row g-3">
                      <div v-for="child in mainLink.children" :key="child.name" class="col-md-6">
                          <div class="bg-white p-2 rounded border d-flex justify-content-between align-items-center hover-effect">
                            <span class="small text-dark fw-bold d-flex align-items-center">
                                <i :class="child.icon" class="ms-2 text-muted opacity-50"></i> {{ child.text }}
                            </span>
                            
                            <!-- زر التبديل الفرعي -->
                            <div class="form-check form-switch">
                              <input 
                                class="form-check-input" 
                                type="checkbox" 
                                v-model="settings.menu_visibility[child.name]"
                              >
                            </div>
                          </div>
                      </div>
                  </div>
                </div>

              </div>
</div>
            </div>

            <!-- Tab 3: الخدمات والجمهور -->
            <div v-if="activeTab === 'services'" class="animate-fade">
              <h5 class="section-title text-success">الخدمات الجماهيرية (للطلاب)</h5>
              
              <div class="row g-4">
                <!-- أرقام الجلوس -->
                <div class="col-12">
                  <div class="card border-primary bg-primary-subtle">
                    <div class="card-body d-flex justify-content-between align-items-center">
                      <div>
                        <h6 class="fw-bold mb-1 text-primary"><i class="fas fa-id-card ms-2"></i> أرقام الجلوس</h6>
                        <small>إتاحة البحث عن رقم الجلوس ومقر اللجنة للطلاب.</small>
                      </div>
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="settings.services.is_seating_active" style="transform: scale(1.5);">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- النتيجة -->
                <div class="col-12">
                  <div class="card border-success bg-success-subtle">
                    <div class="card-body d-flex justify-content-between align-items-center">
                      <div>
                        <h6 class="fw-bold mb-1 text-success"><i class="fas fa-poll ms-2"></i> إعلان النتيجة</h6>
                        <small>فتح باب الاستعلام عن النتائج وطباعة الشهادات.</small>
                      </div>
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="settings.services.is_results_active" style="transform: scale(1.5);">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- التظلمات -->
                <div class="col-12">
                  <div class="card border-warning bg-warning-subtle">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <div>
                          <h6 class="fw-bold mb-1 text-dark"><i class="fas fa-file-contract ms-2"></i> التظلمات الإلكترونية</h6>
                          <small>استقبال طلبات التظلم والدفع.</small>
                        </div>
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" v-model="settings.services.is_appeals_active" style="transform: scale(1.5);">
                        </div>
                      </div>
                      
                      <div v-if="settings.services.is_appeals_active" class="row g-3 border-top border-dark-subtle pt-3">
                        <div class="col-md-4">
                          <label class="small fw-bold">تاريخ البدء</label>
                          <input type="date" v-model="settings.services.appeals_start_date" class="form-control form-control-sm bg-white">
                        </div>
                        <div class="col-md-4">
                          <label class="small fw-bold">تاريخ الانتهاء</label>
                          <input type="date" v-model="settings.services.appeals_end_date" class="form-control form-control-sm bg-white">
                        </div>
                        <div class="col-md-4">
                          <label class="small fw-bold">سعر المادة (ج.م)</label>
                          <input type="number" v-model="settings.services.appeal_cost" class="form-control form-control-sm bg-white">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tab 4: الفصول الدراسية -->
            <div v-if="activeTab === 'seasons'" class="animate-fade">
              <h5 class="section-title text-info">تهيئة النظام والفصل الدراسي</h5>
              <div class="alert alert-info">
                <strong>تنويه:</strong> تغيير الفصل الدراسي سيغير مصادر البيانات (أعمدة الدرجات والجلوس) تلقائياً في النظام.
              </div>
              <div class="mb-4">
                  <label class="form-label fw-bold">الفصل الدراسي النشط</label>
                  <select v-model="settings.seasons.activeSeason" class="form-select form-select-lg border-info text-info fw-bold">
                    <option value="term1">الفصل الدراسي الأول (Term 1)</option>
                    <option value="term2">الفصل الدراسي الثاني (Term 2)</option>
                    <option value="round2">الدور الثاني (Round 2)</option>
                  </select>
              </div>
              
              <div class="card bg-light border-0">
                  <div class="card-header fw-bold">تكويد الأعمدة (Database Mapping)</div>
                  <div class="card-body">
                      <div class="row g-3">
                          <div class="col-md-4">
                              <label class="small text-muted">عمود الجلوس</label>
                              <input type="text" v-model="settings.seasons.columns.seat" class="form-control font-monospace" readonly>
                          </div>
                          <div class="col-md-4">
                              <label class="small text-muted">عمود السري</label>
                              <input type="text" v-model="settings.seasons.columns.secret" class="form-control font-monospace" readonly>
                          </div>
                          <div class="col-md-4">
                              <label class="small text-muted">جدول الرصد</label>
                              <input type="text" v-model="settings.seasons.columns.grades_table" class="form-control font-monospace" readonly>
                          </div>
                      </div>
                  </div>
              </div>
            </div>

            <!-- Tab 5: Grading -->
            <div v-if="activeTab === 'grading'" class="animate-fade">
              <h5 class="section-title text-warning">قواعد الرصد والكنترول</h5>
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label fw-bold">حد الرأفة الأقصى</label>
                  <div class="input-group">
                      <input type="number" v-model="settings.grading.mercyLimit" class="form-control">
                      <span class="input-group-text">درجات</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold">جبر الكسور</label>
                  <select v-model="settings.grading.rounding" class="form-select">
                    <option value="student_favor">لصالح الطالب (أي كسر = 1)</option>
                    <option value="mathematical">رياضي (0.5 فأكثر)</option>
                  </select>
                </div>
                <div class="col-12 mt-3">
                    <div class="form-check form-switch p-3 bg-light rounded border">
                        <input class="form-check-input float-end ms-3" type="checkbox" v-model="settings.grading.allowOverEdit" style="transform: scale(1.3)">
                        <label class="form-check-label fw-bold me-5">السماح بتعديل الدرجات بعد الاعتماد النهائي؟</label>
                    </div>
                </div>
              </div>
            </div>

            <!-- Tab 6: Control -->
            <div v-if="activeTab === 'control'" class="animate-fade">
               <h5 class="section-title text-dark">أرقام الجلوس والسري</h5>
               <div class="row g-3">
                   <div class="col-md-6">
                       <label class="fw-bold">بداية الجلوس</label>
                       <input type="number" v-model="settings.control.defaultSeatStart" class="form-control">
                   </div>
                   <div class="col-md-6">
                       <label class="fw-bold">بداية السري</label>
                       <input type="number" v-model="settings.control.defaultSecretStart" class="form-control">
                   </div>
               </div>
            </div>

            <!-- Tab 7: Printing -->
            <div v-if="activeTab === 'printing'" class="animate-fade">
                <h5 class="section-title text-secondary">ترويسة وتذييل التقارير</h5>
                <div class="row g-3">
                    <div class="col-md-6">
                        <label class="fw-bold">السطر الأول (المديرية)</label>
                        <input type="text" v-model="settings.printing.headerLine1" class="form-control">
                    </div>
                    <div class="col-md-6">
                        <label class="fw-bold">السطر الثاني (اللجنة)</label>
                        <input type="text" v-model="settings.printing.headerLine2" class="form-control">
                    </div>
                    <div class="col-12 mt-4">
                        <label class="fw-bold border-bottom d-block mb-2">مسميات التوقيع (Footer)</label>
                        <div class="row">
                            <div class="col-4"><input type="text" v-model="settings.printing.sign1" class="form-control" placeholder="التوقيع 1"></div>
                            <div class="col-4"><input type="text" v-model="settings.printing.sign2" class="form-control" placeholder="التوقيع 2"></div>
                            <div class="col-4"><input type="text" v-model="settings.printing.sign3" class="form-control" placeholder="التوقيع 3"></div>
                        </div>
                    </div>
                </div>
            </div>
<!-- ============================================================ -->
<!-- Tab: Users Manager (القسم الجديد للتعديل الفردي) -->
<!-- ============================================================ -->
<div v-if="activeTab === 'users_manager'" class="animate-fade">
    <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
        <div>
            <h5 class="m-0 text-primary"><i class="fas fa-users-cog ms-2"></i> دليل المستخدمين والصلاحيات</h5>
            <small class="text-muted">تعديل بيانات الدخول، المدارس، واللجان لكل مستخدم.</small>
        </div>
        
        <div class="d-flex gap-2">
            <div class="input-group">
                <span class="input-group-text bg-white"><i class="fas fa-search"></i></span>
                <input v-model="userSearch" @input="fetchUsers" type="text" class="form-control" placeholder="بحث بالاسم أو الكود..." style="width: 250px;">
            </div>
            <button @click="openUserModal(null)" class="btn btn-primary px-3 fw-bold shadow-sm">
                <i class="fas fa-plus ms-1"></i> مستخدم جديد
            </button>
        </div>
    </div>

    <!-- جدول عرض المستخدمين -->
    <div class="table-responsive">
        <table class="table table-hover align-middle text-center mb-0 border">
            <thead class="bg-light">
                <tr>
    <th>#</th>
    <th>الاسم</th>
    <th>اسم الدخول</th>
    <th>الصلاحية</th>
    <th>المدرسة / اللجنة</th>
    <th>الحالة</th> <!-- عمود جديد -->
    <th>تحكم</th>
</tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in usersList.data" :key="user.id" :class="{'table-secondary': !user.is_active}"> <!-- تظليل الصف الموقوف -->
    <td>{{ user.id }}</td>
    <td class="fw-bold text-start">{{ user.name }}</td>
    <td class="font-monospace text-primary">{{ user.email }}</td>
    <td><span class="badge" :class="getRoleBadge(user.role)">{{ user.role }}</span></td>
    <td class="small text-muted">
        <div v-if="user.school_name"><i class="fas fa-school ms-1"></i> {{ user.school_name }}</div>
        <div v-if="user.committee_name"><i class="fas fa-building ms-1"></i> {{ user.committee_name }}</div>
    </td>
    
    <!-- عمود الحالة (الجديد) -->
    <td>
        <div class="form-check form-switch d-flex justify-content-center">
            <!-- لاحظ استخدام user.is_active مباشرة -->
            <input 
                class="form-check-input" 
                type="checkbox" 
                :checked="user.is_active" 
                @change="toggleUserStatus(user)"
                style="transform: scale(1.4); cursor: pointer;"
                title="تفعيل/إيقاف"
            >
        </div>
        <span class="small fw-bold" :class="user.is_active ? 'text-success' : 'text-danger'">
            {{ user.is_active ? 'نشط' : 'موقوف' }}
        </span>
    </td>
                  
                  
                  
                    <td>
                        <button @click="openUserModal(user)" class="btn btn-sm btn-outline-dark mx-1" title="تعديل">
                            <i class="fas fa-edit"></i>
                        </button>
                        <button @click="deleteUser(user.id)" class="btn btn-sm btn-outline-danger" title="حذف">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </td>
                </tr>


                <tr v-if="!usersList.data || usersList.data.length === 0">
                    <td colspan="6" class="py-4 text-muted">لا يوجد مستخدمين لعرضهم</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-center mt-3" v-if="usersList.last_page > 1">
            <nav>
            <ul class="pagination pagination-sm">
                <li class="page-item" :class="{disabled: !usersList.prev_page_url}"><button class="page-link" @click="fetchUsers(usersList.current_page - 1)">السابق</button></li>
                <li class="page-item active"><span class="page-link">{{ usersList.current_page }}</span></li>
                <li class="page-item" :class="{disabled: !usersList.next_page_url}"><button class="page-link" @click="fetchUsers(usersList.current_page + 1)">التالي</button></li>
            </ul>
            </nav>
    </div>
</div>

<!-- ============================================================ -->
<!-- Modal: نافذة الإضافة/التعديل -->
<!-- ============================================================ -->
<div v-if="showUserModal" class="modal fade show d-block" style="background: rgba(0,0,0,0.5); z-index: 1060;">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg">
            <div class="modal-header bg-dark text-white">
                <h5 class="modal-title fw-bold">
                    <i class="fas fa-user-edit ms-2"></i> {{ editingUser ? 'تعديل بيانات مستخدم' : 'إضافة مستخدم جديد' }}
                </h5>
                <button type="button" class="btn-close btn-close-white" @click="closeUserModal"></button>
            </div>
            <div class="modal-body p-4">
                <form @submit.prevent="saveUser">
                    <div class="row g-3">
                        <!-- البيانات الأساسية -->
                        <div class="col-md-6">
                            <label class="form-label fw-bold small">الاسم الكامل</label>
                            <input v-model="userForm.name" type="text" class="form-control" required>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-bold small">اسم الدخول (Email/ID)</label>
                            <input v-model="userForm.email" type="text" class="form-control" required>
                        </div>
                        
                        <div class="col-md-6">
                            <label class="form-label fw-bold small">كلمة المرور</label>
                            <input v-model="userForm.password" type="password" class="form-control" :placeholder="editingUser ? 'اتركها فارغة إذا لم ترد التغيير' : 'مطلوب'" :required="!editingUser">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-bold small">الصلاحية (Role)</label>
                            <select v-model="userForm.role" class="form-select" required>
                                <option value="admin">مسؤول نظام (Admin)</option>
                                <option value="control_head">رئيس كنترول</option>
                                <option value="control_member">عضو كنترول</option>
                                <option value="committee_head">رئيس لجنة</option>
                                <option value="school_manager">مدير مدرسة</option>
                                <option value="operations_admin">غرفة عمليات</option>
                            </select>
                        </div>

                        <div class="col-12"><hr class="my-2"></div>
                        
                        <!-- بيانات المدرسة واللجنة -->
                        <h6 class="text-primary fw-bold mb-2">تخصيص المدرسة واللجنة (اختياري)</h6>

                        <div class="col-md-4">
                            <label class="form-label small text-muted">اسم المدرسة</label>
                            <input v-model="userForm.school_name" type="text" class="form-control form-control-sm">
                        </div>
                        <div class="col-md-4">
                            <label class="form-label small text-muted">كود المدرسة (Code)</label>
                            <input v-model="userForm.Code_School" type="number" class="form-control form-control-sm">
                        </div>
                         <div class="col-md-4">
                            <label class="form-label small text-muted">رقم المدرسة (ID)</label>
                            <input v-model="userForm.school_id" type="number" class="form-control form-control-sm">
                        </div>

                        <div class="col-md-6">
                            <label class="form-label small text-muted">اسم اللجنة</label>
                            <input v-model="userForm.committee_name" type="text" class="form-control form-control-sm">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small text-muted">رقم اللجنة (ID)</label>
                            <input v-model="userForm.committee_id" type="number" class="form-control form-control-sm">
                        </div>
                    </div>

                    <div class="mt-4 text-end border-top pt-3">
                        <button type="button" class="btn btn-secondary me-2" @click="closeUserModal">إلغاء</button>
                        <button type="submit" class="btn btn-primary fw-bold px-5">
                            <i class="fas fa-save ms-2"></i> حفظ البيانات
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
            <!-- Tab 8: Users (استيراد المستخدمين - بالكود الأصلي الخاص بك) -->
            <div v-if="activeTab === 'users'" class="animate-fade">
               <h5 class="section-title text-secondary">استيراد المستخدمين</h5>
               
               <div class="alert alert-info border-info">
                <i class="fas fa-lightbulb me-2"></i>
                <strong>تعليمات:</strong> انسخ الأعمدة التالية من ملف الإكسيل (الاسم | اسم الدخول | كلمة المرور | الصلاحية | اسم اللجنة | رقم اللجنة | اسم المدرسة | رقم المدرسة | كود المدرسة) والصقها هنا.
               </div>

               <div class="mb-3">
                   <label class="form-label fw-bold">منطقة اللصق (Ctrl+V)</label>
                   <textarea 
                    v-model="excelRawData" 
                    @paste="handlePaste" 
                    class="form-control font-monospace bg-light" 
                    rows="6" 
                    placeholder="بيانات المستخدمين..."
                   ></textarea>
               </div>
               
               <div class="d-flex justify-content-end mb-4">
                   <button @click="parsedUsers = []; excelRawData = ''" class="btn btn-outline-secondary me-2">مسح</button>
                   <button @click="processData" class="btn btn-dark px-4 fw-bold" :disabled="!excelRawData">معالجة البيانات</button>
               </div>
               
               <!-- جدول المعاينة -->
               <div v-if="parsedUsers.length > 0" class="card border-success">
                   <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
                       <h6 class="fw-bold m-0">تم التعرف على {{ parsedUsers.length }} مستخدم</h6>
                       <button @click="saveUsersToBackend" class="btn btn-light btn-sm fw-bold text-success" :disabled="saving">تأكيد وحفظ</button>
                   </div>
                   <div class="table-responsive" style="max-height: 350px;">
                       <table class="table table-bordered table-sm text-center small mb-0 table-hover align-middle">
                           <thead class="table-light sticky-top">
                               <tr>
                                   <th>#</th>
                                   <th>الاسم الكامل</th>
                                   <th>اسم الدخول</th>
                                   <th>كلمة المرور</th>
                                   <th>الصلاحية</th>
                                   <th>اسم اللجنة</th>
                                   <th>رقم اللجنة</th>
                                   <th>اسم المدرسة</th>
                                   <th>رقم المدرسة</th>
                                   <th>كود المدرسة</th>
                               </tr>
                           </thead>
                           <tbody>
                               <tr v-for="(user, index) in parsedUsers" :key="index" :class="user.valid ? '' : 'table-danger'">
                                   <td>{{ index + 1 }}</td>
                                   <td class="fw-bold">{{ user.name }}</td>
                                   <td class="text-primary font-monospace">{{ user.email }}</td>
                                   <td class="text-muted">******</td>
                                   <td><span class="badge" :class="getRoleBadge(user.role)">{{ user.role }}</span></td>
                                   
                                   <td class="text-primary font-monospace">{{ user.committee_name }}</td>
                                   <td class="text-primary font-monospace">{{ user.committee_id }}</td>
                                   <td class="text-primary font-monospace">{{ user.school_name }}</td>
                                   <td class="text-primary font-monospace">{{ user.school_id }}</td>
                                   <td class="text-primary font-monospace">{{ user.Code_School }}</td>
                               </tr>
                           </tbody>
                       </table>
                   </div>
               </div>
            </div>

            <!-- Tab 9: Advanced (Danger Zone) -->
            <div v-if="activeTab === 'advanced'" class="animate-fade">
                <div class="alert alert-danger border-danger d-flex align-items-center shadow-sm">
                    <i class="fas fa-radiation fa-2x me-3"></i>
                    <div>
                        <h5 class="fw-bold m-0">منطقة الخطر</h5>
                        <p class="mb-0 small">الإجراءات هنا لا رجعة فيها. يرجى توخي الحذر الشديد.</p>
                    </div>
                </div>
                <div class="list-group">
                    <div class="list-group-item d-flex justify-content-between align-items-center p-3">
                        <div>
                            <h6 class="text-danger fw-bold mb-1">تصفير أرقام الجلوس والسري</h6>
                            <small class="text-muted">سيتم حذف جميع الأرقام المسندة للطلاب.</small>
                        </div>
                        <button class="btn btn-outline-danger btn-sm" @click="confirmAction('reset_seats')">تنفيذ</button>
                    </div>
                    
                    <div class="list-group-item d-flex justify-content-between align-items-center mt-3 p-3">
                        <div>
                            <h6 class="fw-bold text-danger mb-1">حذف جميع رصد الدرجات</h6>
                            <small class="text-muted">حذف كامل لدرجات المواد للفصل الدراسي الحالي.</small>
                        </div>
                        <button class="btn btn-outline-danger btn-sm" @click="confirmAction('reset_grades')">تنفيذ</button>
                    </div>
                </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/axios';
import { appLinks } from '@/config/menuLinks'; 

export default {
  name: "SystemSettings",
  data() {
    return {
         menuKey: 0,
      activeTab: 'general',
      saving: false,
      excelRawData: '',
      parsedUsers: [],
       usersList: {},
    userSearch: '',
    showUserModal: false,
    editingUser: null,
      userForm: { 
        name: '', email: '', password: '', role: 'school_manager', 
        school_name: '', school_id: '', Code_School: '', 
        committee_name: '', committee_id: '' 
    },
      // الروابط المستوردة
      allLinks: appLinks,

      settings: {
        general: { controlName: 'كنترول الشهادة الإعدادية', newsTicker: '', is_maintenance_mode: false, maintenance_secret: '', maintenance_message: '' },
        menu_visibility: {}, 
        services: { is_seating_active: false, is_results_active: false, is_appeals_active: false, appeals_start_date: '', appeals_end_date: '', appeal_cost: 35 },
        seasons: { activeSeason: 'term1', columns: { seat: 'Seating_No_1', secret: 'Secret_No_1', grades_table: 'grades_t1' } },
        grading: { mercyLimit: 2.5, rounding: 'student_favor', allowOverEdit: false },
        control: { defaultSeatStart: 1001, defaultSecretStart: 5001, committeeCapacity: 20, secretLogic: 'sequential' },
        printing: { headerLine1: 'مديرية التربية والتعليم', headerLine2: 'لجنة النظام والمراقبة', sign1: 'مسئول الحاسب', sign2: 'رئيس الكنترول', sign3: 'مدير المديرية' }
      }
    };
  },
  computed: {
    // الفلترة الذكية للروابط (لإظهار الأقسام المستهدفة فقط في لوحة التحكم)
    filteredMenuLinks() {
        const targetRoles = ['control_head', 'control_member', 'committee_head', 'school_manager'];
        
        return this.allLinks.filter(link => {
            const hasTargetRole = link.roles.some(r => targetRoles.includes(r));
            // استبعاد أقسام الأدمن الخاصة (Setting, AdminDashboard)
            const isSystemSection = ['Setting', 'AdminDashboard', 'AdminDashboard_Room'].includes(link.name);
            
            return hasTargetRole && !isSystemSection;
        });
    }
  },
  mounted() {
    this.fetchSettings();
  },
  methods: {
   async fetchSettings() {
  try {
    const res = await api.get('/admin/system-settings');
    const serverData = res.data;
    
    // 1. دمج الإعدادات العامة
    this.settings = { ...this.settings, ...serverData };

    // 2. تجهيز كائن الرؤية (Visibility Object) محلياً أولاً
    const savedVisibility = serverData.menu_visibility || {};
    const newVisibility = {};

    // 3. بناء الكائن بدقة (التأكد من وجود مفتاح لكل رابط)
    this.allLinks.forEach(link => {
        // الرابط الرئيسي: نأخذ القيمة المحفوظة، أو true إذا لم توجد
        newVisibility[link.name] = savedVisibility[link.name] !== false;

        if (link.hasChildren) {
            link.children.forEach(child => {
                // الرابط الفرعي
                newVisibility[child.name] = savedVisibility[child.name] !== false;
            });
        }
    });

    // 4. تعيين الكائن الجاهز للإعدادات
    this.settings.menu_visibility = newVisibility;

    // 5. السحر: إجبار الواجهة على التحديث الآن
    this.menuKey += 1; 

  } catch (e) {
    console.error(e);
  }
},

    async saveAllSettings() {
      this.saving = true;
      try {
        await api.post('/admin/system-settings/save', this.settings);

        
        localStorage.setItem('app_settings', JSON.stringify(this.settings));
        window.dispatchEvent(new Event('menu-settings-changed'));
        alert("تم الحفظ بنجاح");
      } catch (e) {
        alert("خطأ في الحفظ");
      } finally {
        this.saving = false;
      }
    },
    
    // --- دوال استيراد المستخدمين (بالكود الأصلي الخاص بك) ---
    processData() { if (!this.excelRawData) return; this.parseExcelText(this.excelRawData); },
    handlePaste(e) { setTimeout(() => { this.parseExcelText(this.excelRawData); }, 100); },
    
    parseExcelText(text) {
      const rows = text.trim().split('\n');
      this.parsedUsers = rows.map(row => {
        const cols = row.split('\t'); 
        
        // التقاط الأعمدة حسب ترتيبك الأصلي
        const name = cols[0]?.trim();
        const email = cols[1]?.trim();
        const password = cols[2]?.trim();
        const role = cols[3]?.trim() || 'user'; 

        const committee_name = cols[4]?.trim();
        const committee_id = cols[5]?.trim();
        const school_name = cols[6]?.trim();
        const school_id = cols[7]?.trim();
        const Code_School = cols[8]?.trim();

        return {
          name, email, password, role, committee_name, committee_id, school_name, school_id, Code_School,
          valid: (name && email && password) ? true : false
        };
      }).filter(u => u.name); 
    },
    
    async saveUsersToBackend() {
      const validUsers = this.parsedUsers.filter(u => u.valid);
      if (validUsers.length === 0) return alert("لا توجد بيانات صالحة");
      if(!confirm(`سيتم إضافة ${validUsers.length} مستخدم. هل أنت متأكد؟`)) return;

      this.saving = true;
      try {
        await api.post('/admin/users/import', { users: validUsers });
        alert("تمت الإضافة بنجاح!");
        this.excelRawData = '';
        this.parsedUsers = [];
      } catch (error) {
        alert("خطأ أثناء الحفظ");
      } finally {
        this.saving = false;
      }
    },
     async fetchUsers(page = 1) {
        try {
            const res = await api.get('/admin/users-manager', { 
                params: { page, search: this.userSearch } 
            });
            this.usersList = res.data;
        } catch(e) { console.error(e); }
    },

    openUserModal(user) {
        this.editingUser = user;
        if(user) {
            // ملء النموذج ببيانات المستخدم للتعديل (مع تصفير الباسورد)
            this.userForm = { 
                name: user.name, 
                email: user.email, 
                role: user.role, 
                password: '', 
                school_name: user.school_name,
                school_id: user.school_id,
                Code_School: user.Code_School,
                committee_name: user.committee_name,
                committee_id: user.committee_id
            };
        } else {
            // نموذج فارغ للإضافة
            this.userForm = { 
                name: '', email: '', password: '', role: 'school_manager', 
                school_name: '', school_id: '', Code_School: '', 
                committee_name: '', committee_id: '' 
            };
        }
        this.showUserModal = true;
    },

    closeUserModal() {
        this.showUserModal = false;
        this.editingUser = null;
    },

    async saveUser() {
        try {
            if(this.editingUser) {
                // تعديل
                await api.post(`/admin/users-manager/${this.editingUser.id}/update`, this.userForm);
                alert("تم تعديل بيانات المستخدم بنجاح");
            } else {
                // إضافة جديد
                await api.post('/admin/users-manager/create', this.userForm);
                alert("تم إضافة المستخدم بنجاح");
            }
            this.closeUserModal();
            this.fetchUsers(); // تحديث القائمة
        } catch(e) {
            alert("حدث خطأ! ربما اسم الدخول مستخدم من قبل.");
        }
    },

    async deleteUser(id) {
        if(!confirm("هل أنت متأكد تماماً من حذف هذا المستخدم؟")) return;
        try {
            await api.delete(`/admin/users-manager/${id}`);
            this.fetchUsers();
            alert("تم الحذف.");
        } catch(e) { alert("فشل الحذف"); }
    },
async toggleUserStatus(user) {
    // حفظ الحالة القديمة للتراجع في حالة الخطأ
    const originalStatus = user.is_active;
    
    // تغيير الحالة ظاهرياً فوراً (Optimistic UI)
    user.is_active = !user.is_active;

    try {
        await api.post(`/admin/users-manager/${user.id}/toggle-status`);
        // (اختياري) رسالة نجاح صغيرة
        // this.$toast.success("تم تغيير الحالة");
    } catch (e) {
        // التراجع عند الخطأ
        user.is_active = originalStatus;
        alert(e.response?.data?.message || "حدث خطأ أثناء تغيير الحالة");
    }
},
   
    getRoleBadge(role) {
      const roleLower = role.toLowerCase();
      if(roleLower.includes('admin')) return 'bg-danger';
      if(roleLower.includes('control')) return 'bg-primary';
      if(roleLower.includes('school')) return 'bg-success';
      return 'bg-secondary';
    },

    confirmAction(action) {
      const code = prompt("هذا إجراء خطير! أدخل كود التأكيد (1234):");
      if(code === '1234') alert(`تم التنفيذ: ${action}`);
      else alert("كود خاطئ");
    }
  },
  watch: {
    'settings.seasons.activeSeason'(newVal) {
        if(newVal === 'term1') {
            this.settings.seasons.columns = { seat: 'Seating_No_1', secret: 'Secret_No_1', grades_table: 'grades_t1' };
        } else if(newVal === 'term2') {
            this.settings.seasons.columns = { seat: 'Seating_No_2', secret: 'Secret_No_2', grades_table: 'grades_t2' };
        } else {
            this.settings.seasons.columns = { seat: 'Seating_No_R2', secret: 'Secret_No_R2', grades_table: 'grades_r2' };
        }
    }
  }
};
</script>

<style scoped>
.list-group-item.active {
    background-color: #f8f9fa;
    color: #0d6efd;
    border-color: transparent;
    border-right: 4px solid #0d6efd;
    font-weight: bold;
}
.list-group-item {
    border: none;
    padding: 12px 15px;
    font-weight: 500;
    color: #555;
}
.list-group-item:hover { background-color: #f8f9fa; }

/* العناوين */
.section-title {
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 20px;
    font-weight: bold;
}

/* أيقونات القوائم */
.icon-box {
    width: 35px; height: 35px;
    display: flex; align-items: center; justify-content: center;
}

.hover-effect:hover {
    background-color: #f1f3f5;
}

.animate-fade {
    animation: fadeIn 0.4s ease-in-out;
}
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.font-monospace { font-family: 'Courier New', monospace; color: #d63384; }
.btn-hover:hover { transform: translateY(-2px); }
</style>